import styled from 'styled-components';
import {
  colorInterfaceDarkDown,
  colorInterfaceDarkDeep,
  fontSizeSm,
  spacingInlineMd,
  fontFamilyBase,
  fontSizeXs,
  fontWeightExtrabold,
  fontWeightRegular,
  spacingInlineXxsExtra,
  spacingInlineXs,
} from '@useblu/ocean-tokens/web/tokens';

import { breakpointTo } from '@useblu/utils';

export interface IWrapperProps {
  $columns?: number;
}

export const Wrapper = styled.div<IWrapperProps>`
  display: flex;
  flex-direction: column;

  ${breakpointTo('bpMedium')} {
    height: 100%;
    width: 100%;

    flex: 1;

    .page__container {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1;
      height: 100%;
    }

    .navigation__container {
      display: none;
    }
  }
`;

export const Title = styled.h3`
  margin: 0;
  padding: ${spacingInlineXxsExtra} 0 ${spacingInlineXs};

  color: ${colorInterfaceDarkDeep};
  font-family: ${fontFamilyBase};
  font-size: ${fontSizeSm};
  font-style: normal;
  font-weight: ${fontWeightExtrabold};
`;

export const Description = styled.p`
  margin: 0;
  color: ${colorInterfaceDarkDown};
  font-family: ${fontFamilyBase};
  font-size: ${fontSizeXs};
  font-style: normal;
  font-weight: ${fontWeightRegular};

  ${breakpointTo('bpSmall')} {
    padding: 0px 16px 16px 0px;
  }
`;
